import { useTheme } from '@mui/material';

export const IntroIcon5 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 12C9 10.8954 9.89543 10 11 10H28C30.2091 10 32 11.7909 32 14V24C32 26.2091 30.2091 28 28 28H16.9225C15.7074 28 14.5581 28.5524 13.799 29.5012L11.6713 32.1609C10.7855 33.2681 9 32.6417 9 31.2238V12Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 8.5H10C8.61929 8.5 7.5 9.61929 7.5 11V27.426C7.5 27.8798 8.05589 28.0989 8.36553 27.7671L10.7174 25.2472C11.7576 24.1328 13.2137 23.5 14.7382 23.5H26C27.3807 23.5 28.5 22.3807 28.5 21V11C28.5 9.61929 27.3807 8.5 26 8.5ZM10 7C7.79086 7 6 8.79086 6 11V27.426C6 29.2412 8.22354 30.1176 9.46211 28.7906L11.814 26.2707C12.5705 25.4602 13.6295 25 14.7382 25H26C28.2091 25 30 23.2091 30 21V11C30 8.79086 28.2091 7 26 7H10ZM33 14.25C33.4142 14.25 33.75 14.5858 33.75 15V29.882C33.75 31.1829 32.381 32.029 31.2174 31.4472L27.0869 29.382C26.9133 29.2952 26.7219 29.25 26.5279 29.25H20.5C20.0858 29.25 19.75 28.9142 19.75 28.5C19.75 28.0858 20.0858 27.75 20.5 27.75H26.5279C26.9548 27.75 27.3759 27.8494 27.7577 28.0403L31.8882 30.1056C32.0544 30.1887 32.25 30.0678 32.25 29.882V15C32.25 14.5858 32.5858 14.25 33 14.25ZM13.5 17.5C14.3284 17.5 15 16.8284 15 16C15 15.1716 14.3284 14.5 13.5 14.5C12.6716 14.5 12 15.1716 12 16C12 16.8284 12.6716 17.5 13.5 17.5ZM20 16C20 16.8284 19.3284 17.5 18.5 17.5C17.6716 17.5 17 16.8284 17 16C17 15.1716 17.6716 14.5 18.5 14.5C19.3284 14.5 20 15.1716 20 16ZM23.5 17.5C24.3284 17.5 25 16.8284 25 16C25 15.1716 24.3284 14.5 23.5 14.5C22.6716 14.5 22 15.1716 22 16C22 16.8284 22.6716 17.5 23.5 17.5Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
